import script from "./Preinscriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./Preinscriptions.vue?vue&type=script&setup=true&lang=js"

import "./Preinscriptions.vue?vue&type=style&index=0&id=7b7975fd&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7975fd"]])

export default __exports__